import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Layout, Rocket, CheckCircle2 } from 'lucide-react';
export function Pricing() {
  const plans = [{
    icon: <FileText size={32} className="text-nova-accent" data-id="element-282" />,
    name: 'LANDING PAGE',
    description: 'Ideal para negocios o emprendedores que necesitan una presencia web clara, rápida y profesional para generar confianza y facilitar el contacto con sus clientes.',
    price: '597.000',
    features: ['Diseño web profesional', 'Diseño responsive adaptado a celular', 'Estructura orientada a conversión', 'Botón de WhatsApp', 'Formulario de contacto', 'Hosting por 1 año incluido', 'Dominio por 1 año incluido', 'Redacción de textos', 'Logotipo básico', 'Branding básico', 'SEO básico', 'Publicación del sitio', 'Enlaces a redes sociales', 'Soporte inicial'],
    highlighted: false
  }, {
    icon: <Layout size={32} className="text-nova-accent" data-id="element-283" />,
    name: 'SITIO WEB PARA NEGOCIO',
    badge: '⭐ MÁS POPULAR',
    description: 'Para negocios que necesitan una página más completa, con mejor estructura para presentar sus servicios, su marca y sus canales de contacto de forma profesional.',
    price: '897.000',
    features: ['Diseño web profesional', 'Diseño responsive adaptado a celular', 'Estructura más completa', 'Secciones según el negocio', 'Botón de WhatsApp', 'Formulario de contacto', 'Mapa o galería si aplica', 'Hosting por 1 año incluido', 'Dominio por 1 año incluido', 'Redacción de textos', 'Logotipo básico', 'Branding básico', 'SEO básico', 'Publicación del sitio', 'Enlaces a redes sociales', 'Hasta 2 correos corporativos', 'Soporte inicial'],
    highlighted: true
  }, {
    icon: <Rocket size={32} className="text-nova-accent" data-id="element-284" />,
    name: 'WEB PARA NEGOCIO PLUS',
    description: 'Para negocios que necesitan una página más avanzada con funciones adicionales como tienda online o catálogo, logrando una presencia digital sólida y profesional.',
    price: '1.297.000',
    features: ['Diseño web profesional', 'Diseño responsive adaptado a celular', 'Estructura amplia y personalizada', 'Más secciones según la necesidad', 'Botón de WhatsApp', 'Formulario de contacto', 'Mapa o galería si aplica', 'Tienda online o catálogo', 'Carga inicial básica de productos', 'Hosting por 1 año incluido', 'Dominio por 1 año incluido', 'Redacción de textos', 'Logotipo básico', 'Branding básico', 'SEO básico', 'Publicación del sitio', 'Enlaces a redes sociales', 'Hasta 3 correos corporativos', 'Soporte inicial'],
    highlighted: false
  }];
  return <section id="servicios" className="py-32 bg-nova-bg-alt" data-id="element-285">
      <div className="max-w-7xl mx-auto px-6" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-287">
          <h2 className="text-3xl md:text-4xl font-bold text-nova-text" data-id="element-288">
            Elige el Plan Perfecto Para Tu Negocio
          </h2>
          <div className="w-16 h-[3px] bg-nova-accent mx-auto mt-4 mb-4" data-id="element-289" />
          <p className="text-lg text-nova-text-muted max-w-2xl mx-auto" data-id="element-290">
            Sin letras pequeñas. Sin sorpresas. Todo lo que necesitas para estar
            online de forma profesional desde el primer día.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start" data-id="element-291">
          {plans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className={`relative bg-nova-card rounded-2xl p-8 flex flex-col h-full transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_20px_rgba(0,212,255,0.15)] ${plan.highlighted ? 'border-2 border-nova-accent shadow-glow lg:-mt-4 lg:mb-4' : 'border border-nova-bg-alt'}`} data-id="element-292">
              {plan.badge && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-nova-accent text-nova-bg px-4 py-1 rounded-full text-sm font-bold whitespace-nowrap" data-id="element-293">
                  {plan.badge}
                </div>}

              <div className="mb-6" data-id="element-294">
                <div className="mb-4" data-id="element-295">{plan.icon}</div>
                <h3 className="text-2xl font-bold text-nova-text mb-2" data-id="element-296">
                  {plan.name}
                </h3>
                <p className="text-sm text-nova-text-muted min-h-[80px]" data-id="element-297">
                  {plan.description}
                </p>
              </div>

              <div className="mb-8" data-id="element-298">
                <span className="text-sm text-nova-text-muted" data-id="element-299">Desde</span>
                <div className="flex items-baseline gap-1" data-id="element-300">
                  <span className="text-xl font-semibold text-nova-text" data-id="element-301">
                    COP
                  </span>
                  <span className="text-4xl font-bold text-nova-accent" data-id="element-302">
                    ${plan.price}
                  </span>
                </div>
              </div>

              <div className="flex-grow" data-id="element-303">
                <ul className="space-y-3 mb-8" data-id="element-304">
                  {plan.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-305">
                      <CheckCircle2 className="text-green-500 shrink-0 mt-0.5" size={18} data-id="element-306" />
                      <span className="text-sm text-nova-text-muted" data-id="element-307">
                        {feature}
                      </span>
                    </li>)}
                </ul>
              </div>

              <a href={`https://wa.me/573508108717?text=Hola,%20estoy%20interesado%20en%20el%20plan%20${plan.name}`} target="_blank" rel="noopener noreferrer" className={`w-full text-center px-10 py-4 rounded-full font-bold transition-all duration-300 ${plan.highlighted ? 'bg-gradient-to-r from-[#00D4FF] to-[#0080FF] text-nova-bg shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:shadow-[0_0_30px_rgba(0,212,255,0.7)] hover:scale-105' : 'bg-transparent border-2 border-[#00D4FF] text-white hover:bg-[#00D4FF]/10'}`} data-id="element-308">
                QUIERO ESTE PLAN
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}